// Helpers for the charts that merge several series onto a single dataset keyed
// by an x value (lead time), with per-series values under dynamic keys
// (`<seriesKey>__<id>`). Shared by the booking-curve (UH-cat mode) and price
// charts.

export type MergedRow = Record<string, number | null>;

// Stable key from a set of ids — used as a react-query key part so the query
// re-runs only when the actual set changes (order-independent).
export const joinCatIds = (ids: number[]): string =>
  [...ids].sort((a, b) => a - b).join(",");

// Accumulate rows keyed by `xField`: `row(x)` returns the (get-or-created) row
// to assign series values onto; `rows()` returns them sorted by x.
export const createRowMerger = (xField: string) => {
  const map = new Map<number, MergedRow>();
  return {
    row(x: number): MergedRow {
      let row = map.get(x);
      if (!row) {
        row = { [xField]: x };
        map.set(x, row);
      }
      return row;
    },
    rows(): MergedRow[] {
      return [...map.values()].sort(
        (a, b) => ((a[xField] as number) ?? 0) - ((b[xField] as number) ?? 0)
      );
    },
  };
};
